import { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { Mail } from "lucide-react";
import { Card } from "@/components/ui/card";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const ST = {
  connected: ["Connected", "bg-emerald-50 text-emerald-700"],
  needs_reconnect: ["Needs sign-in", "bg-amber-50 text-amber-700"],
  not_connected: ["Not connected", "bg-gray-100 text-gray-500"],
};

// Command Center: Outlook mailbox status per location.
export const OutlookHealthPanel = () => {
  const [d, setD] = useState(null);
  useEffect(() => { axios.get(`${API}/outlook/connections`).then((r) => setD(r.data.locations)).catch(() => setD([])); }, []);
  if (!d) return null;
  return (
    <div className="mt-8" data-testid="outlook-health-panel">
      <div className="mb-2 flex items-center gap-2 text-xs font-bold uppercase tracking-wide text-gray-500">
        <Mail className="h-3.5 w-3.5" /> Outlook mailboxes <span className="text-gray-300">·</span>
        <Link to="/settings" className="font-medium normal-case text-indigo-600 hover:underline">connect in Settings</Link>
      </div>
      <Card className="divide-y divide-gray-100 overflow-hidden">
        {d.map((l) => {
          const [label, cls] = ST[l.status] || ST.not_connected;
          return (
            <div key={l.location_id} className="flex items-center gap-3 px-4 py-2.5 text-sm" data-testid={`outlook-health-${l.location_id}`}>
              <span className="font-semibold text-gray-900 w-40 truncate">{l.name}</span>
              <span className="flex-1 truncate text-gray-500">{l.email || "—"}{l.last_error && l.status !== "connected" ? ` · ${l.last_error}` : ""}</span>
              <span className="hidden sm:block text-[11px] text-gray-400">{l.last_refresh_at ? `refreshed ${new Date(l.last_refresh_at).toLocaleString()}` : ""}</span>
              <span className={`text-[11px] font-semibold ${l.gingr_location_ok ? "text-emerald-600" : "text-rose-600"}`} data-testid={`outlook-health-gingr-${l.location_id}`}>{l.gingr_location_ok ? `Gingr loc ${l.gingr_location_id || "single"} ✓` : "Gingr location ID missing!"}</span>
              {l.status === "connected" && <span className="text-[11px] text-gray-500">{l.send_enabled ? `Sending ON · ${l.daily_limit}/day` : "Sending OFF"}</span>}
              <span className={`rounded-full px-2 py-0.5 text-xs font-bold ${cls}`}>{label}</span>
            </div>
          );
        })}
      </Card>
    </div>
  );
};
